/**
 * Transforms Firestore reason configurations into modal dropdown options.
 *
 * @module formatReasonDropdownOptions
 */

import { ReasonModel } from "../../../../../data-model/reasonModel";

/** A reason option displayed by the status-update modal dropdown. */
export interface ReasonDropdownOption {
  /** User-facing reason text. */
  label: string;
  /** Persisted reason value. */
  value: string;
}

/**
 * Sorts configured reasons by ascending display order and maps them to options.
 *
 * @param reasons - Firestore-configured reason records.
 * @returns Label-value dropdown options ordered from the lowest order value.
 */
export const formatReasonDropdownOptions = (
  reasons: ReasonModel[],
): ReasonDropdownOption[] =>
  [...reasons]
    .sort((firstReason, secondReason) => firstReason.order - secondReason.order)
    .map(({ reason }) => ({ label: reason, value: reason }));
